import { Routes } from '@angular/router';
import { HomePage } from './features/home/home';

export const routes: Routes = [
  { path: '', component: HomePage, title: 'Trivia' },
];
